import { render } from "./CommandCell.vue?vue&type=template&id=65958153&scoped=true"
import script from "./CommandCell.vue?vue&type=script&lang=js"
export * from "./CommandCell.vue?vue&type=script&lang=js"

import "./CommandCell.vue?vue&type=style&index=0&id=65958153&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65958153"]])

export default __exports__